// extracted by mini-css-extract-plugin
module.exports = {"enableClose":"poscon_enableClose__39oZK"};